/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Batch_Subtitle_Export_Event_Groups_AriaInputs */



/**
* | output |
* | --- |
* | "Select event groups for export" |
*
* @param {Batch_Subtitle_Export_Event_Groups_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const batch_subtitle_export_event_groups_aria = /** @type {((inputs?: Batch_Subtitle_Export_Event_Groups_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Batch_Subtitle_Export_Event_Groups_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionner les groupes d’événements pour l’export")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignisgruppen für den Export auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona gruppi di eventi per l'esportazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите группы событий для экспорта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccionar grupos de eventos para exportar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择要导出的事件组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エクスポートするイベントグループを選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("निर्यात के लिए इवेंट समूह चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione os grupos de eventos para exportação.")
	return /** @type {LocalizedString} */ ("Select event groups for export")
});